<div id="content" class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12" id="slide1">
            <img src="./assets/images/programa-domicilio-crop-u52829.jpg" alt="User Image" id="background">
            <div class="col-lg-5 col-md-6 col-sm-7 col-xs-7 col-lg-offset-3 col-md-offset-3 col-sm-offset-3 col-xs-offset-3" id="logoWoden">
                <img src="./assets/images/logo-woden-pro-neg1-hd-u69940-fr.png" alt="">
            </div>
            <div class="col-lg-6 col-md-6 col-sm-8 col-xs-8 col-lg-offset-3 col-md-offset-3 col-sm-offset-3 col-xs-offset-2 " id="slid2">
                <div class="gracias text-center">
                    <p>¡Gracias!</p>
                    <p>Te contactaremos</p>
                    <p>para programar</p>
                    <p>el servicio</p>
                    <div id="lineFeed"></div>
                </div>
                <div class="horarios text-center">
                    <p>Horarios</p>
                    <p>L-V : 8am-8pm</p>
                    <p>Fines de semana y festivos:</p>
                    <p>8am-5pm</p>
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
            <div id="form">
                <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                    <div id="line"></div>
                    <h2><strong>¡Importante!</strong></h2>
                    <p>Ten a la mano el número IMEI, Serial y Modelo de tu equipo. Consúltalos en la factura, en la caja del equipo, o marcando *#06#. Nuestros Agentes del Contact Center, en breve te llamarán.</p>
                </div>
                <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                    <p>Mientras tanto te invitamos a conocer más de nuestros productos:</p>
                </div>
                <div class="col-lg-10 col-md-10 col-sm-12 col-xs-12 col-lg-offset-1 col-md-offset-1">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <img src="./assets/images/atributos-iphone7-black-rem_480x480-u12657-fr.png" alt="">
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                                <h4>iPhone 7 Black</h4>
                                <h4 style="color: red;">desde $ 780.000</h4>
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                                <a href="https://tienda.woden.com.co/collections/celulares-apple-iphone/products/apple-iphone-7-128-negromate" target="_blank" class="btn btn-link" style="color: white; border: solid 1px white; background-color: #FF7700; border-radius: 15px; width: 120px;">Ver
                                    en tienda </a>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <img src="./assets/images/atributos-iphone7-rose-gold-rem_480x480-u12682-fr.png" alt="">
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                                <h4>iPhone 7 Rose Gold</h4>
                                <h4 style="color: red;">desde $ 780.000</h4>
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                                <a href="https://tienda.woden.com.co/collections/celulares-apple-iphone/products/apple-iphone-7-32-rosegold" target="_blank" class="btn btn-link" style="color: white; border: solid 1px white; background-color: #FF7700; border-radius: 15px; width: 120px;">Ver
                                    en tienda </a>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <img src="./assets/images/atributos-iphone8-plus-space-gray-rem_07660bda-8efa-47c1-9f47-8a037872908c_480x480-u13698-fr.png" alt="">
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                                <h4>iPhone 8 Plus Gray</h4>
                                <h4 style="color: red;">desde $ 1.850.000</h4>
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                                <a href="https://tienda.woden.com.co/collections/celulares-apple-iphone/products/apple-iphone-8-plus-64-spacegray" target="_blank" class="btn btn-link" style="color: white; border: solid 1px white; background-color: #FF7700; border-radius: 15px; width: 120px;">Ver
                                    en tienda </a>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <img src="./assets/images/atributos-iphone8-plus-gold-rem_480x480-u13636-fr.png" alt="">
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                                <h4>iPhone 8 Plus Gold</h4>
                                <h4 style="color: red;">desde $ 1.850.000</h4>
                            </div>
                            <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 col-xs-offset-1">
                                <a href="https://tienda.woden.com.co/collections/celulares-apple-iphone/products/apple-iphone-8-plus-64-gold" target="_blank" class="btn btn-link" style="color: white; border: solid 1px white; background-color: #FF7700; border-radius: 15px; width: 120px;">Ver
                                    en tienda </a>
                            </div>
                        </div>
                    </div>
                    <div style="text-align: center;">
                        <a href="https://tienda.woden.com.co/" target="_blank" class="btn btn-link botona" id="tienda">Visitar
                        la tienda en línea</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" id="footer2">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <h3>Sobre Woden</h3>
                <p style="font-size: 10px; width: 90%;">
                    Somos aliados de negocios de marcas líderes en tecnología y comunicaciones a nivel mundial. Potenciamos el ciclo de vida útil de equipos tecnológicos usados, y ofrecemos a personas y empresas una amplia variedad de productos y servicios que hacen la vida
                    más fácil, generan ahorros y ayudan al medio ambiente.
                </p>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                <h3 style="margin-left: 22px;">Accesos rápidos</h3>
                <ul style="font-size: 10px">
                    <li>Sitio Web Woden</li>
                    <li>Tienda online</li>
                    <li>Gestión de orden de servicio</li>
                    <li>Contacto</li>
                    <li>Servicio al cliente</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 " id="footer3">
            <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <p style="font-size: 10px;"><strong>WODEN COLOMBIA SAS.</strong> Todos los derechos reservados</p>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <p style="font-size: 10px;">Avenida calle 13 # 56 - 35 Bogotá, Colombia</p>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                <p style="font-size: 10px;">+57(1)355 8200</p>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-12 " id="footer4">

        </div>
    </div>
</div>